import { faArrowUp } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useState, useEffect } from 'react';

const GoToTopButton = () => {
    const [isVisible, setIsVisible] = useState(false);

    // const toggleVisibility = () => {
    //     setIsVisible(prevState => !prevState);
    // };

    useEffect(() => {
        const handleScroll = () => {
            const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
            // setIsVisible(scrollTop > window.innerHeight);
            setIsVisible(scrollTop > 700);
        };

        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const handleClick = () => {
        document.documentElement.scrollTop = 0;
    };

    return (
        <button
            onClick={handleClick}
            style={{
                position: 'fixed',
                bottom: '50%',
                right: '20px',
                backgroundColor: 'white',
                border: 'none',
                display: isVisible ? 'block' : 'none'
            }}
        >
            <FontAwesomeIcon icon={faArrowUp} bounce size='2xl'/>
        </button>
    );
};

export default GoToTopButton;
